// extracted by mini-css-extract-plugin
module.exports = {"link":"Email-module--link--1oK7j"};